import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import Checkbox from '@/common/components/Checkbox'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton';
import TextField from '@/common/components/TextField'
import useDebounce from '@/common/hooks/useDebounce'
import { useClientRole } from '@/features/clientRoles/hooks/useClientRole'
import { ChevronsRightIcon, SearchIcon } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'

const Show = () => {
  const { id } = useParams()

  const [search, setSearch] = useDebounce('')

  const {
    data: role,
    isPending: roleIsPending,
    error: roleError = {} as any,
    refetch: refetchRole,
  } = useClientRole({ id: id || '' })

  const disableUpdateButton = roleIsPending || roleError?.status === 403

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton
            fallback='/client-roles'
            searchLastRouteFromFallback
          />
          <p className="text-white-400 font-normal">Cargos e permissões - Cliente</p>
          <ChevronsRightIcon color="#ffffffb3" />
          {!roleIsPending && <h2 className="font-bold">{role?.display_name}</h2>}
        </div>
        <Link
          to={disableUpdateButton ? '' : `/client-roles/${id}/edit`}
          className={disableUpdateButton ? 'cursor-default' : ''}
        >
          <Button name="submit" operationKlassToCheckPermission='Admin::Client::Roles::Update' type="button" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
            Editar
          </Button>
        </Link>
      </div>
      {roleIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={roleError?.status}
          refetchFunction={refetchRole}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] max-h-[calc(100vh-128px)] overflow-y-auto">
            <p className="text-lg font-bold">Cargo</p>
            <TextField label="Nome do cargo" value={role?.display_name} disabled />
            <TextField label="Descrição do cargo" value={role?.description} disabled />
            <TextField name="level" label="Nível" value={role?.level?.toString()} disabled />
            <Checkbox
              label="Permitir redefinição de senha do usuário cliente por outros"
              className="items-center gap-x-2"
              labelClassName="text-[0.625rem] font-light italic cursor-default"
              checked={role?.permit_reset_client_user_password_by_others}
              disabled
            />
            <Box className="flex flex-col gap-4">
              <p>Permissões</p>
              <TextField
                LeftIcon={<SearchIcon />}
                placeholder="Pesquisar permissões"
                onChange={(e) => setSearch((e.target as HTMLInputElement).value)}
              />
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-2 overflow-auto min-h-14 max-h-[calc(100vh-566px)]">
                {role?.permission_roles
                  ?.filter((permissionRole) =>
                    permissionRole.permission.display_name.toLowerCase().includes(search.toLowerCase()),
                  )
                  ?.map((permissionRole) => (
                    <div key={permissionRole.id} className="flex gap-2 items-center">
                      <Checkbox
                        name={permissionRole.permission.display_name}
                        label={permissionRole.permission.display_name}
                        labelClassName="max-w-[360px] text-wrap break-words cursor-default"
                        checked
                        disabled
                      />
                    </div>
                  ))}
              </div>
            </Box>
          </Box>
        </ErrorMessageWrapper>
      )}
    </>
  )
}

export default Show
